export function capitalizeFirstLetter(string = '') {
  return string.replace(/^\w/, (match) => match.toUpperCase());
}
